import CloseIcon from '@mui/icons-material/Close';
import { Box } from 'shared/mui/Box';
import { CircularProgress } from 'shared/mui/CircularProgress/CircularProgress';
import { IconButton } from 'shared/mui/IconButtons';

type ImageUploaderImageStateProps = {
  preview?: string;
  handleImageClick: () => void;
  onClick?: React.MouseEventHandler<HTMLButtonElement> | undefined;
};

export const ImageUploaderImageState = ({
  handleImageClick,
  onClick,
  preview,
}: ImageUploaderImageStateProps) => (
  <Box sx={{ display: 'inline-block', paddingY: '24px' }}>
    {preview ? (
      <>
        <img
          alt="Click to upload"
          onClick={handleImageClick}
          src={preview}
          style={{ cursor: 'pointer', maxWidth: '104px', objectFit: 'contain' }}
        />
        <IconButton
          onClick={onClick}
          sx={{
            position: 'absolute',
            top: '4px',
            right: '4px',
            cursor: 'pointer',
            width: '32px',
            height: '32px',
          }}
        >
          <CloseIcon sx={{ color: '#D32F2F' }} />
        </IconButton>
      </>
    ) : (
      <CircularProgress />
    )}
  </Box>
);
